
import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import MaterialTable from "material-table";
import '../App.css';
import TablePagination from '@material-ui/core/TablePagination';


function GeneralInfo(props) {
  const url = "/api";
  const token = localStorage.getItem('token');
  var [detRows, setDetRows] = React.useState([]);
  const [detectorIDs, setDetectorIDs] = React.useState([]);
  const history = useHistory();

  async function checkToken() {
    const token = localStorage.getItem('token');
    let options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Access-Control-Allow-Origin': '*',
        'x-access-token': token
      },
    }
    let response = await fetch(url + '/', options).catch(err => {
      console.log(err);
    });
    if (response.status !== 200) {
      props.setToken(null);
    } else {
      props.setToken(token);
    }
  }

  async function logOut(){
    if(token){
      props.setToken(null);
    }
  }

  async function computeDetectorsInformation() {
    let options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Access-Control-Allow-Origin': '*',
        'x-access-token': token
      },
    }
    let response = await fetch(url + '/', options).catch(err => {
      console.log(err);
    });
    if (response.status !== 200) {
      if (response.status === 401) {
        localStorage.removeItem('token');
      }
      console.log("Can't get the detectors information");
    }
    var dataReceived = await response.json();

    var rows = [];
    dataReceived.forEach(detector => {
      var asdtServices = 0;
      var systemServices = 0;
      
      if(detector.services){
        if(detector.services.length > 0){
          detector.services.forEach(service => {
            if (service.type === "asdt") {
              asdtServices++;
            } else if (service.type === "system") {
              systemServices++;
            }
          });
        }
      }
      
      const dateLast = new Date(detector.lastMessage);
      const dateNow = new Date();
      const months = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
      ];
      const days = [
        'Domingo',
        'Lunes',
        'Martes',
        'Miércoles',
        'Jueves',
        'Viernes',
        'Sábado'
      ];
      const monthName = months[dateLast.getMonth()];
      const dayName = days[dateLast.getDay()];
      const year = dateLast.getFullYear();
      const dayNum = dateLast.getDate();
      const hours = (0 + dateLast.getHours().toString()).slice(-2);
      const minutes = (0 + dateLast.getMinutes().toString()).slice(-2);
      const seconds = (0 + dateLast.getSeconds().toString()).slice(-2);
      const formattedFecha = `${dayName}, ${dayNum} ${monthName} ${year}`;
      const formattedHora = `${hours}:${minutes}:${seconds}`;

      var lastMessage = "";
      if (dayName !== undefined) {
        lastMessage = formattedFecha + ' a las ' + formattedHora;
      }
      var CPU = undefined;
      if (detector.cpu !== undefined) {
        CPU = Math.round(detector.cpu * 100) / 100;
      };

      const diffTime = Math.ceil(Math.abs(dateLast - dateNow) / (1000));
      //const emojiActive = diffTime <= 120 ? String.fromCodePoint(0x1f7e2) : String.fromCodePoint(0x1f534)
      const emojiActive = (
      <span
        title={diffTime <= 120 ? "Active" : "Inactive"}
        style={{
          display: 'inline-block',
          width: 20,
          height: 20,
          borderRadius: '50%',
          backgroundColor: diffTime <= 120 ? '#076129' : '#be0000',
        }}
        ></span>
      );
      var responseTime = "-"
      if(detector.responseTime !== null && detector.responseTime !== undefined){
        responseTime = detector.responseTime;
      }

      rows.push({
        id: detector.ident,
        active: emojiActive,
        alias: detector.alias,
        last_message: lastMessage,
      })
    });
    return (rows);
  }

  React.useEffect(() => {
    var timer = undefined;
    checkToken();
    async function fetchData() {
      var rows = await computeDetectorsInformation();
      var detIDsArray = [];
      setDetRows(rows);
      rows.forEach(element => {
        detIDsArray.push(element.id);
      });
      setDetectorIDs(detIDsArray);
      localStorage.setItem("detectorIDs", detIDsArray);
      timer = setTimeout(() => {
        fetchData();
      }, 120000);

    }
    fetchData();
    return () => timer !== undefined ? clearTimeout(timer) : fetchData();
  }
    , []); // eslint-disable-line react-hooks/exhaustive-deps


  const data = (rowsData) => {
    return ({
      columns: [
        {
          title: "ACTIVE",
          field: "active",
          align: 'center',
          cellStyle: { width: 10, minWidth: 10 },
          headerStyle: { fontSize: 'larger' }

        },
        {
          title: "ID",
          field: "id",
          align: 'center',
          cellStyle: { width: 300, minWidth: 300 },
          headerStyle: { fontSize: 'larger' },
        },
        {
          title: "ALIAS",
          field: "alias",
          align: 'center',
          cellStyle: { width: 500, minWidth: 500 },
          headerStyle: { fontSize: 'larger' }
        },
        {
          title: "LAST STATUS",
          field: "last_message",
          align: 'center',
          headerStyle: { fontSize: '1em' },
          cellStyle: { fontSize: '0.89em', width: 100, minWidth: 100}
        }
      ],
      rows: rowsData,
    });
  };

  if (detRows !== []) {
    return (
      <div>
        <div style={{display:'flex', justifyContent:'space-between'}}>
          <h1>Manager</h1>
          <Button style={{marginLeft: '20px', width:'60px', borderRadius: '20px', backgroundColor:'#076129', borderColor:'#076129'}} className='asdt-btn' onClick={logOut} variant="primary"><i className="fas fa-sign-out-alt"></i></Button>
        </div>
        <br></br>
        <br></br>
        <hr></hr>
        <div style={{ paddingTop: '20px', display: "flex", flexDirection: "column" }}>
          <MaterialTable
            title="Devices information"
            data={data(detRows).rows.reverse()}
            columns={data(detRows).columns}
            options={{search: true, paging: true, headerStyle: { fontSize: '1em', paddingRight: '10px' }, pageSize: 20, pageSizeOptions: [20, 50, 100] }}
            style={{ textAlign: 'center' , borderRadius: '20px'}}
            localization={
              {
                root: {
                  display: 'flex',
                  overflowX: 'hide',
                }
              },
              {
                header: {
                  actions: ""
                }
              }
            }

            actions={[
              {
                icon: 'info',
                tooltip: 'See Details',
                onClick: (event, rowData) => {
                  localStorage.setItem("detSelected", rowData.id);
                  history.push('/detector');
                }
              }
            ]}
          />
        </div>
      </div>
    );

  }

}

export default GeneralInfo;
